import {
  Eye,
  Lock,
  ShieldCheck,
  Stethoscope,
  LineChart,
} from "lucide-react";

const pillars = [
  {
    icon: Eye,
    title: "Explainable AI",
    desc: "Every result comes with a clear breakdown of the factors that influenced it — no black boxes.",
  },
  {
    icon: Lock,
    title: "Privacy First",
    desc: "Your responses are used only for your assessment. Nothing is sold, shared, or used to identify you.",
  },
  {
    icon: ShieldCheck,
    title: "Preventive Focus",
    desc: "We surface potential risks early so healthier habits can start before symptoms escalate.",
  },
  {
    icon: Stethoscope,
    title: "AI Assists, Doctors Decide",
    desc: "SilentScan AI never diagnoses. It's guidance you bring to your qualified healthcare professional.",
  },
  {
    icon: LineChart,
    title: "Transparent Recommendations",
    desc: "Each suggestion is evidence-based — with the why, the expected benefit, and when to consult a doctor.",
  },
];

export default function TrustSection() {
  return (
    <section
      id="trust"
      data-testid="trust-section"
      className="relative py-28 md:py-36"
    >
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-3xl mx-auto mb-16">
          <div className="text-xs font-semibold uppercase tracking-[0.25em] text-cyan-400 mb-5">
            Trust & Transparency
          </div>
          <h2 className="font-display text-4xl sm:text-5xl font-semibold tracking-[-0.03em] leading-tight">
            Why you can trust{" "}
            <span className="text-gradient-cyan">SilentScan AI.</span>
          </h2>
          <p className="mt-6 text-zinc-400 text-lg leading-relaxed">
            Responsible AI in healthcare means clarity, consent and clinical
            humility. These are the five principles we build every feature on.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {pillars.map((p, i) => (
            <div
              key={p.title}
              data-testid={`trust-pillar-${i}`}
              className="glass-card rounded-3xl p-7 hover:-translate-y-1 hover:border-cyan-400/40 transition-all duration-300"
            >
              <div className="w-11 h-11 rounded-xl bg-gradient-to-br from-[#0B3D91]/30 to-cyan-500/10 border border-cyan-500/20 flex items-center justify-center mb-5">
                <p.icon className="w-5 h-5 text-cyan-400" />
              </div>
              <h3 className="font-display text-lg font-semibold">{p.title}</h3>
              <p className="mt-3 text-sm text-zinc-400 leading-relaxed">
                {p.desc}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
